export default "__VITE_ASSET__Bnby3VG8__";